import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import textContent from 'react-addons-text-content';
import { GroupTitle, GroupTitleText, GroupTitleAfter } from '../styled/ItemGroup';

var ItemGroup = /*#__PURE__*/function (_Component) {
  _inherits(ItemGroup, _Component);

  var _super = _createSuper(ItemGroup);

  function ItemGroup() {
    _classCallCheck(this, ItemGroup);

    return _super.apply(this, arguments);
  }

  _createClass(ItemGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          elemAfter = _this$props.elemAfter,
          isCompact = _this$props.isCompact,
          title = _this$props.title,
          label = _this$props.label,
          innerRef = _this$props.innerRef,
          role = _this$props.role;

      var ariaLabel = function () {
        if (label) {
          return textContent(label);
        }

        if (title) {
          return textContent(title);
        }

        return '';
      }();

      return /*#__PURE__*/React.createElement("div", {
        "aria-label": ariaLabel,
        role: role,
        ref: innerRef
      }, title ? /*#__PURE__*/React.createElement(GroupTitle, {
        "aria-hidden": "true",
        isCompact: isCompact
      }, /*#__PURE__*/React.createElement(GroupTitleText, null, title), elemAfter ? /*#__PURE__*/React.createElement(GroupTitleAfter, {
        innerRef: function innerRef(r) {
          _this.headingAfterElement = r;
        }
      }, elemAfter) : null) : null, children);
    }
  }]);

  return ItemGroup;
}(Component);

_defineProperty(ItemGroup, "defaultProps", {
  role: 'group'
});

export { ItemGroup as default };